import { relaunchApi } from '@/logic/relaunchApi'

export default {
  async getChatThread(participantId) {
    const response = await relaunchApi.post('/chat/threads', { participantId })
    return response.data
  },
  async setAutoTranslate(chatThreadId, enabled) {
    const response = await relaunchApi.post(`/chat/threads/${encodeURIComponent(chatThreadId)}/auto-translate`, { enabled })
    return response.data
  },
  async notifyAboutNewMessage(body) {
    // In prod (and staging) this happens via azure event grid events, so we don't need this.
    if (process.env.NODE_ENV === 'production') {
      return null
    }
    const response = await relaunchApi.post('/chat/notifications/new-message', body)
    return response.data
  },
  async searchMessages(chatThreadId, query, page = 1) {
    const response = await relaunchApi.get(`/chat/threads/${encodeURIComponent(chatThreadId)}/search-messages`, {
      query,
      page,
    })
    return response
  },
  async getMessagesByType(chatThreadId, type, page = 1) {
    const response = await relaunchApi.get(`/chat/threads/${encodeURIComponent(chatThreadId)}/messages-by-type`, {
      type,
      page,
    })
    return response
  },
  async addReaction(chatThreadId, messageId, emoji) {
    const response = await relaunchApi.post(
      `/chat/threads/${encodeURIComponent(chatThreadId)}/messages/${encodeURIComponent(messageId)}/reactions`,
      { emoji },
    )
    return response.data
  },
  async removeReaction(chatThreadId, messageId, emoji) {
    const response = await relaunchApi.delete(
      `/chat/threads/${encodeURIComponent(chatThreadId)}/messages/${encodeURIComponent(messageId)}/reactions`,
      { emoji },
    )
    return response.data
  },
}
